import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-contexte-faits-procedure',
  templateUrl: './contexte-faits-procedure.component.html',
  styleUrls: ['./contexte-faits-procedure.component.css']
})
export class ContexteFaitsProcedureComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;
  private subTab: Subscription[] = [];
  private subFormulaire : Subscription;
  
  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
  Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
  sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';

  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public saisieService: SaisieService,
    public filtreService: FiltreService
  ) { }

  ngOnInit(): void {
    // Pour rafraichir les variables possedant des controles croisés inter onglets !!
      // AlertD10
      this.filtreService.refreshErreur(this.subTab, 'dg', 'xxRecuVict', 'contexteFaitsProcedure', 'ddFaitTot');
      // CtrlD7
      this.filtreService.refreshErreur(this.subTab, 'dg', 'xxRecuVict', 'contexteFaitsProcedure', 'ddPlainteTot');
    

    // Calcul auto Total D3 ddPlainteTot : on regarde que les 3 details ne bougent pas sinon on somme
    this.saisieService.calculTotal3_detail(this.formulaire, this.subTab, 'ddPlainteTot', 'ddPlainteOk', 'ddPlainteKo', 'ddPlainteNd');
    this.saisieService.calculTotal3_detail(this.formulaire, this.subTab, 'ddPlainteTot', 'ddPlainteKo', 'ddPlainteOk', 'ddPlainteNd');
    this.saisieService.calculTotal3_detail(this.formulaire, this.subTab, 'ddPlainteTot', 'ddPlainteNd', 'ddPlainteKo', 'ddPlainteOk');
  
  
    // Mises à jours de la synthèse si une zone bouge sur l'onglet
    this.subFormulaire = this.formulaire.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
      this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));
    });
    this.formulaire.updateValueAndValidity();
    
  }

  ngOnDestroy(): void {
    if (this.subFormulaire) {
      this.subFormulaire.unsubscribe();
    }
    if (this.subTab.length !== 0) {
      this.subTab.forEach(element => element.unsubscribe());
    }
  }

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('contexteFaitsProcedure') as UntypedFormGroup;
  }

  public calculTotalTableauD11(): void {
    //Calcul Total ddFaitPersoTot 
    this.saisieService.calculTotal10(this.formulaire, 'ddFaitPersoTot', 'ddFaitPersoHomiVolo', 'ddFaitPersoSexuel', 'ddFaitPersoProxe', 'ddFaitPersoViolen', 'ddFaitPersoHomiInvolo', 'ddFaitPersoBless', 'ddFaitPersoAband', 'ddFaitPersoMenace', 'ddFaitPersoDiscri', 'ddFaitPersoAutr');
  }

  public calculTotalTableauD12(): void {
    //Calcul Total ddFaitBienTot 
    this.saisieService.calculTotal5(this.formulaire, 'ddFaitBienTot', 'ddFaitBienVolSimp', 'ddFaitBienVolAggr', 'ddFaitBienEscro', 'ddFaitBienDegrad', 'ddFaitBienAutr');
  }

  public calculTotalTableauD13(): void {
    //Calcul Total ddFaitCircuTot 
    this.saisieService.calculTotal2(this.formulaire, 'ddFaitCircuTot', 'ddFaitCircuBless', 'ddFaitCircuDegat');
  }

  public calculTotalTableauD1(): void {
    //Calcul Total ddFaitTot 
    this.saisieService.calculTotal4(this.formulaire, 'ddFaitTot', 'ddFaitPersoTot', 'ddFaitBienTot', 'ddFaitCircuTot', 'ddFaitAutr');
  }

  public calculTotalTableauD2(): void {
    //Calcul Total ddCadrePersoTot 
    this.saisieService.calculTotal7(this.formulaire, 'ddCadrePersoTot', 'ddCadrePersoCple', 'ddCadrePersoFam', 'ddCadrePersoPro', 'ddCadrePersoScol', 'ddCadrePersoSpor', 'ddCadrePersoRue', 'ddCadrePersoAutr');

    //Calcul Total ddCadreBienTot 
    this.saisieService.calculTotal7(this.formulaire, 'ddCadreBienTot', 'ddCadreBienCple', 'ddCadreBienFam', 'ddCadreBienPro', 'ddCadreBienScol', 'ddCadreBienSpor', 'ddCadreBienRue', 'ddCadreBienAutr');
  }

}